/* eslint-disable import/no-cycle */
import ApiService from '@/services/ApiService';
import LocalStorageService from '@/services/LocalStorageService';
import { KEY_LANGUAGE } from '@/types/consts';
import { useGeneralStore } from '@/store/generalStore';

export default class LocalizationService {
  public static fetchAndStoreMessages(): void {
    const language = LocalStorageService.getLanguage();
    if (language === null || language === KEY_LANGUAGE.key) {
      useGeneralStore().dataLoading = false;
      useGeneralStore().messages = new Map<string, string>();
      return;
    }
    ApiService.getAndReturnData(`localization/messages/${language}`).then((response: any) => {
      useGeneralStore().dataLoading = false;
      useGeneralStore().messages = new Map<string, string>(Object.entries(response.results.messages));
    });
  }
}
